import Loading from '@components/UI/Loading'

const InfluencerIdentityRowSubmissionsLoading = () => <Loading height={5.25} />

export { InfluencerIdentityRowSubmissionsLoading }
export default InfluencerIdentityRowSubmissionsLoading
